

<div class="container">

  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <img class="w-100" src="images/banner.jpg" alt="...">
        </div>
      </div>
      <div class="row justify-content-center" style="margin-bottom: 100px;">
        <button class="btn btn-primary" (click)="catalogo()">
          <a>
            CATÁLOGO DE FORMACIONES PNA
          </a>
        </button>
      </div>
    </div>
  </div>

</div>
